var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandEmployees(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1334 14.3V25.6999C35.1334 27.5666 34.1334 29.3 32.5168 30.25L22.6168 35.9666C21.0001 36.9 19.0001 36.9 17.3668 35.9666L7.46676 30.25C5.8501 29.3167 4.8501 27.5833 4.8501 25.6999V14.3C4.8501 12.4333 5.8501 10.6999 7.46676 9.74991L17.3668 4.03325C18.9834 3.09992 20.9834 3.09992 22.6168 4.03325L32.5168 9.74991C34.1334 10.6999 35.1334 12.4166 35.1334 14.3Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.3333C22.1447 18.3333 23.8834 16.5946 23.8834 14.4499C23.8834 12.3052 22.1447 10.5667 20 10.5667C17.8553 10.5667 16.1167 12.3052 16.1167 14.4499C16.1167 16.5946 17.8553 18.3333 20 18.3333Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6668 27.7665C26.6668 24.7665 23.6835 22.3333 20.0002 22.3333C16.3168 22.3333 13.3335 24.7665 13.3335 27.7665",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandEmployees);
export default __webpack_public_path__ + "static/media/land_employees.bea66087e9bb079f5d6edc373b56cc2c.svg";
export { ForwardRef as ReactComponent };